import React from 'react'
import styled from 'styled-components'
import Chip, { ChipVariants } from 'core-system/Chip'

const TruncatedChip = styled(Chip)`
  display: inline-block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const colorVariants: Record<
  'green' | 'red' | 'blue' | 'yellow' | 'gray' | 'purple' | 'pink',
  ChipVariants
> = {
  green: 'green',
  red: 'red',
  blue: 'blue',
  yellow: 'yellow',
  gray: 'grey',
  purple: 'purple',
  pink: 'pink',
}

interface ColorPillProps {
  color: 'green' | 'red' | 'blue' | 'yellow' | 'gray' | 'purple' | 'pink'
  text: string
}

const ColorPill = ({ color, text }: ColorPillProps) => {
  return <TruncatedChip variant={colorVariants[color]}>{text}</TruncatedChip>
}

export default ColorPill
